module.exports = __webpack_public_path__ + "files/fb35c03eb13991a2c88ac766e8e33af5.png";